import { SwitchRow } from '@components/SwitchRow/SwitchRow';
import { visualSearchModesPhrase } from '@lib/utils/searchTypeOptions';
import { observer } from 'mobx-react-lite';

type SkipVisualIndexingToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * "Skip visual indexing" switch for the create-library flow. When on, the library is created
 * transcript-only (`settings.v1.skip.visuals`): faster processing, but no visual search — and it
 * can't be changed later, which is why the hint says so in plain sight rather than in a tooltip.
 */
// observer: visualSearchModesPhrase reads the unified-search debug flag.
export const SkipVisualIndexingToggle = observer(function SkipVisualIndexingToggle({
  checked,
  onChange,
}: SkipVisualIndexingToggleProps) {
  return (
    <SwitchRow
      label="Skip visual indexing"
      hint={`Processes media faster, without ${visualSearchModesPhrase()}. Can't be changed later.`}
      checked={checked}
      onChange={onChange}
    />
  );
});
